import { NgClass, NgTemplateOutlet } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    inject,
    input,
    output,
    TemplateRef,
} from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
    GroupTagComponent,
    UserProfileDialogService,
} from '@interacta-shared/feature-caronte';
import { ApplyPipe } from '@interacta-shared/ui';
import { MemberAvatarComponent } from '@interacta-shared/ui-member';
import {
    getMemberUser,
    isMemberGroup,
    isMemberUser,
    Member,
    MemberClickBehavior,
    MemberFullnamePipe,
} from '@interacta-shared/util-member';
import { TranslatePipe } from '@ngx-translate/core';
import { GroupInfoDialogService } from '../group-info-dialog/group-info-dialog.service';

// Versione amministativa del componente member, aggiunge funzionalità nuove come la chip dello stato dell'utente
// Un giorno andrà mergiata con member per diventare un'unica entità

@Component({
    selector: 'interacta-member-admin',
    templateUrl: './member-admin.component.html',
    imports: [
        MemberAvatarComponent,
        NgClass,
        NgTemplateOutlet,
        MatTooltipModule,
        TranslatePipe,
        GroupTagComponent,
        MemberFullnamePipe,
        ApplyPipe,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MemberAdminComponent {
    private readonly userProfileDialogService = inject(
        UserProfileDialogService,
    );
    private readonly groupInfoDialogService = inject(GroupInfoDialogService);

    member = input.required<Member>();
    customInfo = input<string | null>(null);
    memberClickBehavior =
        input<Omit<MemberClickBehavior, 'profile'>>('preview');
    disabled = input(false);
    infoTemplate = input<TemplateRef<unknown> | null>(null);

    memberSelected = output<Member>();
    readonly getMemberUser = getMemberUser;
    readonly isMemberGroup = isMemberGroup;

    selectMember(): void {
        if (this.memberClickBehavior() === 'preview') {
            const member = this.member();
            if (isMemberUser(member)) {
                this.userProfileDialogService.openDialog(member.user);
            } else {
                this.groupInfoDialogService.openDialog(member.group);
            }
        } else {
            this.memberSelected.emit(this.member());
        }
    }
}
